<template>
    <v-container class="pt-0" fluid>
        <v-row> </v-row>
    </v-container>
</template>

<script>
/**
 * ideas for location settings:
 *
 * seo keywords?
 * profile photo
 * pay date
 * pay period int and freq
 * timezone
 * rooms
 * store
 * pricing
 * inventory
 * address
 * phone
 * email?
 */

import { Link } from "@inertiajs/vue2";

export default {
    props: [],
    components: {
        Link,
    },
};
</script>
